module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "timeline-wrapper"
  }, [_c('b-button', {
    staticClass: "mb-3",
    staticStyle: {
      "font-size": "0.675rem",
      "margin-left": "5px",
      "margin-bottom": "4px"
    },
    attrs: {
      "size": "sm",
      "variant": "primary"
    },
    on: {
      "click": function($event) {
        _vm.toggleSecondTimeline = !_vm.toggleSecondTimeline
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.toggleSecondTimeline ? 'Hide' : 'Show') + " Final Steps\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "assignment-details"
  }, [_c('h3', [_vm._v("Assignment Details")]), _vm._v(" "), _c('div', {
    staticClass: "details-grid"
  }, [_c('div', [_c('strong', [_vm._v("Job No:")]), _vm._v(" " + _vm._s(_vm.eventDet.JobNo))]), _vm._v(" "), _c('div', [_c('strong', [_vm._v("Job Date:")]), _vm._v(" " + _vm._s(_vm.eventDet.JobDate))]), _vm._v(" "), _c('div', [_c('strong', [_vm._v("Raised By:")]), _vm._v(" " + _vm._s(_vm.eventDet.RaisedBy))]), _vm._v(" "), _c('div', [_c('strong', [_vm._v("Raised From:")]), _vm._v(" " + _vm._s(_vm.eventDet.RaisedFrom))]), _vm._v(" "), _c('div', [_c('strong', [_vm._v("Client:")]), _vm._v(" " + _vm._s(_vm.eventDet.ClientName))]), _vm._v(" "), _c('div', [_c('strong', [_vm._v("Sline:")]), _vm._v(" " + _vm._s(_vm.eventDet.SlineName))]), _vm._v(" "), _c('div', [_c('strong', [_vm._v("Transport Type:")]), _vm._v(" " + _vm._s(_vm.eventDet.TransportType))]), _vm._v(" "), _c('div', [_c('strong', [_vm._v("Vessel/Voyage:")]), _vm._v(" " + _vm._s(_vm.eventDet.VesselVoyage))]), _vm._v(" "), _c('div', [_c('strong', [_vm._v("BRF No:")]), _vm._v(" " + _vm._s(_vm.eventDet.BrfNo))]), _vm._v(" "), _c('div', [_c('strong', [_vm._v("IncoTerm:")]), _vm._v(" " + _vm._s(_vm.eventDet.IncoTerm))]), _vm._v(" "), _c('div', [_c('strong', [_vm._v("HBL No:")]), _vm._v(" " + _vm._s(_vm.eventDet.HblNo))]), _vm._v(" "), _c('div', [_c('strong', [_vm._v("MBL No:")]), _vm._v(" " + _vm._s(_vm.eventDet.MblNo))]), _vm._v(" "), _c('div', [_c('strong', [_vm._v("MBL Date:")]), _vm._v(" " + _vm._s((_vm.eventDet.MblDate)))]), _vm._v(" "), _c('div', [_c('strong', [_vm._v("Release Date:")]), _vm._v(" " + _vm._s((_vm.eventDet.MblReleaseDate)))]), _vm._v(" "), _c('div', [_c('strong', [_vm._v("ETA Estimated:")]), _vm._v(" " + _vm._s((_vm.eventDet.EtaEstimated)))]), _vm._v(" "), _c('div', [_c('strong', [_vm._v("ETA Actual:")]), _vm._v(" " + _vm._s((_vm.eventDet.EtaActual)))]), _vm._v(" "), _c('div', {
    style: ((_vm.eventDet && _vm.eventDet.subscription_id) ? 'color: blue;font-weight:bold' : ''),
    on: {
      "click": function($event) {
        (_vm.eventDet && _vm.eventDet.subscription_id) ? _vm.goToSubscriptionPage(_vm.eventDet): ''
      }
    }
  }, [_c('strong', [_vm._v("Booking No:")]), _vm._v(" " + _vm._s((_vm.eventDet.BookingNumber)))]), _vm._v(" "), _c('div', [_c('strong', [_vm._v("Next Port:")]), _vm._v(" " + _vm._s((_vm.eventDet.NextPort)))]), _vm._v(" "), _c('div', [_c('strong', [_vm._v("Current Vessel:")]), _vm._v(" " + _vm._s((_vm.eventDet.CurrentVessel)))]), _vm._v(" "), (
    _vm.eventDet.validity_doc != '' &&
    _vm.eventDet.validity_doc != undefined &&
    _vm.eventDet.validity_doc != null
  ) ? _c('div', {
    attrs: {
      "md": "4"
    }
  }, [(_vm.eventDet.validity_doc) ? _c('span', [(_vm.eventDet.validity_doc.split(',').length > 0) ? _c('b', _vm._l((_vm.sanitizedArray(_vm.eventDet.validity_doc.split(','))), function(item_doc, index_doc) {
    return _c('span', {
      key: index_doc
    }, [(item_doc != '') ? _c('a', {
      staticClass: "btn btn-xs btn-warning",
      staticStyle: {
        "font-size": "0.675rem"
      },
      attrs: {
        "size": "sm",
        "href": "javascript:void(0)"
      },
      on: {
        "click": function($event) {
          _vm.PrintValidity_Doc(item_doc)
        }
      }
    }, [_vm._v("View\n                                Doc - " + _vm._s(index_doc + 1))]) : _vm._e(), _vm._v(" "), _c('br')])
  })) : _vm._e()]) : _vm._e()]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "timeline-container"
  }, _vm._l((_vm.timelineEvents), function(event, index) {
    return _c('div', {
      key: 't1-' + index,
      staticClass: "timeline-step"
    }, [_c('div', {
      staticClass: "circle",
      class: {
        missing: !event.actual && !event.plan, blinking: _vm.shouldBlink(event)
      },
      attrs: {
        "title": event.label
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "port-label"
    }, [_vm._v(_vm._s(event.label))]), _vm._v(" "), _c('div', {
      staticClass: "details"
    }, [(event.plan) ? _c('div', [_c('span', {
      staticClass: "badge badge-info"
    }, [_vm._v("Planned")]), _vm._v(": " + _vm._s(event.plan))]) : _vm._e(), _vm._v(" "), (event.last) ? _c('div', [_c('span', {
      staticClass: "badge badge-warning"
    }, [_vm._v("Last")]), _vm._v(": " + _vm._s(event.last))]) : _vm._e(), _vm._v(" "), (event.actual) ? _c('div', [_c('span', {
      staticClass: "badge badge-success"
    }, [_vm._v("Actual")]), _vm._v(": " + _vm._s(event.actual))]) : _vm._e(), _vm._v(" "), (event.detected) ? _c('div', [_c('span', {
      staticClass: "badge badge-secondary"
    }, [_vm._v("Detected")]), _vm._v(": " + _vm._s(event.detected) + "\n                ")]) : _vm._e(), _vm._v(" "), (!event.plan && !event.last && !event.actual && !event.detected) ? _c('div', {
      staticClass: "missing-text"
    }, [_vm._v("No\n                    Data")]) : _vm._e()]), _vm._v(" "), (index < _vm.timelineEvents.length - 1) ? _c('div', {
      staticClass: "line"
    }) : _vm._e()])
  })), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.toggleSecondTimeline),
      expression: "toggleSecondTimeline"
    }],
    staticClass: "timeline-container second"
  }, _vm._l((_vm.timelineEvents2), function(event, index) {
    return _c('div', {
      key: 't2-' + index,
      staticClass: "timeline-step"
    }, [_c('div', {
      staticClass: "circle",
      class: {
        missing: !event.actual && !event.plan, blinking: _vm.shouldBlink(event)
      },
      attrs: {
        "title": event.label
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "port-label"
    }, [_vm._v(_vm._s(event.label))]), _vm._v(" "), _c('div', {
      staticClass: "details"
    }, [(event.plan) ? _c('div', [_c('span', {
      staticClass: "badge badge-info"
    }, [_vm._v("Planned")]), _vm._v(": " + _vm._s(event.plan))]) : _vm._e(), _vm._v(" "), (event.last) ? _c('div', [_c('span', {
      staticClass: "badge badge-warning"
    }, [_vm._v("Last")]), _vm._v(": " + _vm._s(event.last))]) : _vm._e(), _vm._v(" "), (event.actual) ? _c('div', [_c('span', {
      staticClass: "badge badge-success"
    }, [_vm._v("Actual")]), _vm._v(": " + _vm._s(event.actual))]) : _vm._e(), _vm._v(" "), (event.detected) ? _c('div', [_c('span', {
      staticClass: "badge badge-secondary"
    }, [_vm._v("Detected")]), _vm._v(": " + _vm._s(event.detected) + "\n                ")]) : _vm._e(), _vm._v(" "), (!event.plan && !event.last && !event.actual && !event.detected) ? _c('div', {
      staticClass: "missing-text"
    }, [_vm._v("No\n                    Data")]) : _vm._e()]), _vm._v(" "), (index < _vm.timelineEvents2.length - 1) ? _c('div', {
      staticClass: "line"
    }) : _vm._e()])
  }))], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-06bfd649","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/tracking/ShipmentTimeline.vue
// module id = 2368
// module chunks = 0